import { css } from '@emotion/core';
import { variables as vars } from '@domain-group/fe-brary';
var colour = vars.colour,
  font = vars.font;
var addressFontSize = '15.4px';
export var address = /*#__PURE__*/css("padding-top:5px;color:", colour.neutral700, ";font-family:", font.bodyFontFamily, ";font-size:", addressFontSize, ";");